import { createReducer, on } from '@ngrx/store';
import { FormatPercentPipe } from '../../shared/pipes/FormatPercentPipe';
import { transactionTypes } from '../../shared/utilities/Constants';
import { ViewPageActions } from '../../transaction-view/actions';
import {
  ConfirmationPageActions,
  ReviewPageActions,
  TransactionFormActions,
  StandingAuthorizationsActions,
  WireActions,
  TransactionsTableActions,
} from '../actions';
import { EAuthModelCustomer } from '../models/internal-transfer/EAuthModelCustomer';
import { WireInfo } from '../models/wire/WireInfo';
import { TaxAmountAndPercentageFormatter } from '../../shared/utilities/TaxAmountAndPercentageFormatter';
import { FormatDatePipe } from '../../shared/pipes/FormatDatePipe';
import { amountFormatter } from '../../shared/utilities/AmountFormatter';
import { AccountInfoActions } from '../../account-info-header/actions';
import { AccountInfoResponse } from '../../account-info-header/models';
import { InitReleaseActions } from '../../initiate-and-release/actions';

export const wireInfoKey = 'wireInfo';

export interface State extends WireInfo { }

export const initialWireInfoState: State = {
  processDate: '',
  receivingBankDetails: {
    recBankAba: '',
    recBankName1: '',
    recBankName2: '',
    recBankAddress1: '',
    recBankAddress2: '',
    recBankCountry: '',
    bankPhoneArea: '',
    bankPhoneNum1: '',
    bankPhoneNum2: '',
    intermediaryAccount: '',
    intermediaryName1: '',
    intermediaryName2: '',
    intermediaryAddress1: '',
    intermediaryAddress2: '',
    interPhoneArea: '',
    interPhoneNum1: '',
    interPhoneNum2: '',
    interPhoneExt: '',
  },
  receivingBankDetailsIso: {
    recBankAba: '',
    recBankName: '',
    recBankAddress: {
      department: '',
      streetName: '',
      buildingNumber: '',
      buildingName: '',
      floor: '',
      room: '',
      postCode: '',
      townName: '',
      townLocationName: '',
      districtName: '',
      countrySubDivision: '',
      country: '',
      concatenatedAddress: ''
    },
    recBankPhone: '',
    intermediaryName: '',
    intermediaryAccount: '',
    intermediaryAddress: {
      department: '',
      streetName: '',
      buildingNumber: '',
      buildingName: '',
      floor: '',
      room: '',
      postCode: '',
      townName: '',
      townLocationName: '',
      districtName: '',
      countrySubDivision: '',
      country: '',
      concatenatedAddress: ''
    },
    intermediaryPhone: ''
  },
  receivingBankAba: '',
  abaStatusCode: '',
  abaMessageFields: {
    errorList: [],
    warningList: [],
    atsSystemErrors: [],
  },
  receivingAccountHolder: {
    accountHolderName1: '',
    accountHolderName2: '',
    accountHolderAddress1: '',
    accountHolderAddress2: '',
    countryCode: ''
  },
  receivingAccountHolderIdentifierList: [{
    identifierType: '',
    identifierValue: ''
  }],
  receivingAccountHolderIso: {
    name: '',
    accountHolderStreetNumber: '',
    accountHolderStreetName: '',
    accountHolderApartmentSuiteEtc: '',
    countryCode: '',
    receivingBankCity: '',
    receivingBankState: '',
    zipCode: '',
    department: '',
    buildingName: '',
    floor: '',
    townLocationName: '',
    district: '',
    phone: ''
  },
  withholdFedTax: false,
  withholdStateTax: false,
  stateCd: '',
  fedTaxPercent: '',
  fedTaxAmount: '',
  inputIraFields: {
    stateTaxPercent: '',
    fedTaxPercent: '',
  },
  stateTaxPercent: '',
  stateTaxAmount: '',
  stateHasTaxes: false,
  stateTypeIndicator: '',
  availableCashMMF: '',
  availableCashMargin: '',
  distributionReasonDescription: '',
  distributionReason: {
    code: '',
    subCode: '',
    description: '',
    isTaxExempt: false,
  },
  distributionReasonMap: [],
  pendReasons: [],
  countryList: [],
  processDateFields: {
    isExtendedProcessingWindow: false,
    useExtendedProcessDates: false,
    standardProcessDates: [],
    extendedProcessDates: [],
  },
  wireFee: '',
  eauthAccess: false,
  clientAuthorizationNeeded: false,
  isTransactionFromSLOAOrSLOA: false,
  isBsloaTransaction: false,
  isISOCompliant: false,
  eAuthModel: {
    isTransactionFromSLOA: false,
    eauthSelected: false,
    isTransactionFromSLOAOrSLOA: false,
    numberOfAuthRequired: 0,
    eauthEligibilityServiceSLOAError: false,
    eauthEligibilityServiceDown: false,
    eauthEligibilityServiceSLOAErrorMsg: '',
    isOrgAccount: false,
    accountRestricted: false,
    orgOrEduSavingsAccount: false,
    custAcctAuthorizationsListEmpty: false,
    eauthInd: false,
    eauthSLOAInd: false,
    allAccountHolderIneligible: false,
    numOfIneligibleCust: 0,
    eauthEligibilityServiceDownErrorMsg: '',
    custAcctAuthorizationsList: {
      allAccountHoldersIneligible: false,
      numOfIneligibleCust: 0,
      numOfNotWebEnabledCust: 0,
      totalNumOfAccountHolders: 0,
      eauthInd: false,
      eAuthCustomerList: [],
    },
    custAcctSLOAAuthorizationsList: {
      allAccountHoldersIneligible: false,
      numOfIneligibleCust: 0,
      numOfNotWebEnabledCust: 0,
      totalNumOfAccountHolders: 0,
      eauthInd: false,
      eAuthCustomerList: [],
    },
    transactionType: '',
    submitButtonsDisable: '',
    txnType: '',
  },
  toDetails: {
    accountNumber: '',
    beneficiaryName1: '',
    beneficiaryName2: '',
    beneficiaryAddress1: '',
    beneficiaryAddress2: '',
    beneficiaryCountry: '',
    receivingBankAba: '',
    receivingBankName: [],
    receivingBankAddress: [],
    receivingBankCountry: '',
    receivingBankPhone: '',
    receivingBankType: '',
    intermediaryFields: {
      accountId: '',
      accountIdType: '',
      name1: '',
      name2: '',
      address1: '',
      address2: '',
      phoneFull: '',
      countryName: '',
    },
    creditToFields: {
      accountId: '',
      accountIdType: '',
      name1: '',
      name2: '',
      address1: '',
      address2: '',
      phoneFull: '',
      countryName: '',
    },
    canDisplayIntermediaryPhone: false,
    canDisplayReceivingBankPhone: false,
  },
  loading: false,
  error: '',
  hasError: false,
  detailsCallSucceeded: false,
  detailsCallFailed: false,
  inputCallV3Finished: false,
  inputCallV3Failed: false,
  verifyV3CallFinished: false,
  OneTimeAndSloaWiresVerifyV3Finished: false,
  OneTimeAndSloaWiresVerifyV3Failed: false,
  standingAuthCallSucceeded: false,
  withdrawalAmount: '',
  wireAmount: '',
  canDisplayCreditToInfo: false,
  creditTo: {
    insitutionName1: '',
    insitutionName2: '',
    institutionAddress: '',
    institutionAddressContd: '',
    insitutionAccountNumber: '',
    institutionCountry: '',
    institutionPhoneNumber: ''
  },
  caseId: '',
  caseKey: '',
  transferId: '',
  isFedWire: true,
  requestedDate: '',
  missingThirdPartyAddress: false,
  missingIntermediaryAddress: false,
  hasNDFALPFA: false,
  warningsList: [],
  isPendingOnlyForCTWE: false,
  isSubmitAndCreate: false,
  submitAndCreateToggledOn: false,
  hasCustodianRole: false,
  nickname: '',
  cashieringIraAgreementText: '',
  palAgreementText: '',
  palAgreementAcknowledgement: '',
  foreignCurrencyFields: {
    currencyAmount: '',
    currencyType: '',
    exchangeRate: ''
  },
  authResponse: {
    draftId: '',
    pendForRelease: false,
    canRelease: false,
    pendForReleaseReason: ''
  },
  attestationSubmittedBy: {
    firstName: '',
    lastName: ''
  },
  revalidation: {
    status: '',
    errors: [],
    fieldsUpdated: []
 },
  regShortName: '',
  isEscrow: false,
  transmissionNotes: '',
  receivingBankClearingSysId: '',
  isIrsAba: false,
  taxRemittance: {
      taxId: '',
      taxMonthCode: '',
      taxTypeCode: '',
      taxYear: '',
      additionalInfo: ''
  }
}

export const wireReducer = createReducer(
  initialWireInfoState,
  on(WireActions.wireDetailsCallLoading, (state) => {
    return {
      ...state,
      loading: true
    }
  }),
  on(WireActions.callWireDetails, (state) => {
    return {
      ...state,
      abaStatusCode: '',
      receivingBankDetails: {
        recBankAba: '',
        recBankName1: '',
        recBankName2: '',
        recBankAddress1: '',
        recBankAddress2: '',
        recBankCountry: '',
        bankPhoneArea: '',
        bankPhoneNum1: '',
        bankPhoneNum2: '',
        intermediaryAccount: '',
        intermediaryName1: '',
        intermediaryName2: '',
        intermediaryAddress1: '',
        intermediaryAddress2: '',
        interPhoneArea: '',
        interPhoneNum1: '',
        interPhoneNum2: '',
        interPhoneExt: '',
      },
      receivingBankAba: '',
      abaMessageFields: {
        errorList: [],
        warningList: [],
        atsSystemErrors: [],
      },
      detailsCallSucceeded: false,
      detailsCallFailed: false,
      loading: true,
      error: '',
      hasError: false,
    };
  }),
  on(WireActions.wireDetailsCallSuccessful, WireActions.callwireDetailsV2Successful, (state, response) => {
    const receivingBankName = (response.receivingBankDetails.recBankName1 !== null && response.receivingBankDetails.recBankName1 !== '') ? response.receivingBankDetails.recBankName1 : response.receivingBankDetailsIso.recBankName;
    const receivingBankAddress = (response.receivingBankDetails.recBankAddress1 !== null && response.receivingBankDetails.recBankAddress1 !== '') ? response.receivingBankDetails.recBankAddress1 : response.receivingBankDetailsIso.recBankAddress.townName + " " + response.receivingBankDetailsIso.recBankAddress.countrySubDivision;
    const receivingBankCountry = (response.receivingBankDetails.recBankCountry !== null && response.receivingBankDetails.recBankCountry !=='') ? response.receivingBankDetails.recBankCountry : response.receivingBankDetailsIso.recBankAddress.country;
    return {
      ...state,
      abaStatusCode: response.abaStatusCode,
      receivingBankDetails: {
        recBankAba: response.receivingBankDetails.recBankAba,
        recBankName1: receivingBankName,
        recBankName2: response.receivingBankDetails.recBankName2,
        recBankAddress1: receivingBankAddress,
        recBankAddress2: response.receivingBankDetails.recBankAddress2,
        recBankCountry: receivingBankCountry,
        bankPhoneArea: response.receivingBankDetails.bankPhoneArea,
        bankPhoneNum1: response.receivingBankDetails.bankPhoneNum1,
        bankPhoneNum2: response.receivingBankDetails.bankPhoneNum2,
        intermediaryAccount: response.receivingBankDetails.intermediaryAccount,
        intermediaryName1: response.receivingBankDetails.intermediaryName1,
        intermediaryName2: response.receivingBankDetails.intermediaryName2,
        intermediaryAddress1: response.receivingBankDetails.intermediaryAddress1,
        intermediaryAddress2: response.receivingBankDetails.intermediaryAddress2,
        interPhoneArea: response.receivingBankDetails.interPhoneArea,
        interPhoneNum1: response.receivingBankDetails.interPhoneNum1,
        interPhoneNum2: response.receivingBankDetails.interPhoneNum2,
        interPhoneExt: response.receivingBankDetails.interPhoneExt,
      },
      receivingBankDetailsIso: {
        recBankName: response.receivingBankDetailsIso.recBankName,
        recBankAddress: {
          townName: response.receivingBankDetailsIso.recBankAddress.townName,
          department: "",
          streetName: "",
          buildingNumber: "",
          buildingName: "",
          floor: "",
          room: "",
          postCode: "",
          townLocationName: "",
          districtName: "",
          countrySubDivision: response.receivingBankDetailsIso.recBankAddress.countrySubDivision,
          country: response.receivingBankDetailsIso.recBankAddress.country,
          concatenatedAddress: ""
        },
        recBankAba: response.receivingBankDetailsIso.recBankAba,
        intermediaryAccount: response.receivingBankDetailsIso.intermediaryAccount,
        intermediaryName: response.receivingBankDetailsIso.intermediaryName,
        intermediaryAddress: {
          department: "",
          streetName: "",
          buildingNumber: "",
          buildingName: "",
          floor: "",
          room: "",
          postCode: "",
          townName: response.receivingBankDetailsIso.intermediaryAddress.townName,
          townLocationName: "",
          districtName: "",
          countrySubDivision: response.receivingBankDetailsIso.intermediaryAddress.countrySubDivision,
          country: "",
          concatenatedAddress: ""
        },
        recBankPhone: "",
        intermediaryPhone: ""
      },
      receivingBankAba: response.receivingBankAba,
      abaMessageFields: {
        errorList: response.abaMessageFields.errorList,
        warningList: response.abaMessageFields.warningList,
        atsSystemErrors: response.abaMessageFields.atsSystemErrors,
      },
      isIrsAba: response.isIrsAba,
      detailsCallSucceeded: true,
      detailsCallFailed: false,
      loading: false,
      error: '',
      hasError: false,
    };
  }),
  on(WireActions.wireDetailsCallFailed, (state, err) => {
    return {
      ...state,
      detailsCallSucceeded: false,
      detailsCallFailed: true,
      loading: false,
      error: err.message,
      hasError: true,
    };
  }),
  on(WireActions.callWireInputV3, WireActions.callWireInputV3TemplateFlow, (state) => {
    return {
      ...state,
      aba: '',
    recipient: '',
    toAccount: '',
    selectedDate: '',
    amount: '',
    isEscrow: false,
    transmissionNotes: '',
    trustIncomePercent: '',
    trustPrincipalPercent: '',
    trustTaxCategory: '',
    trustTaxCode: '',
    trustPaidFor: '',
    trustComment: '',
    taxWithholdingsFormGroup: {
      fedTaxPercent: '',
      fedTaxAmount: '',
      stateTaxPercent: '',
      stateTaxAmount: '',
      distributionReason: '',
      stateHasTaxes: false,
      distributionReasonMap: [],
    },
    receivingBankName1: '',
    receivingBankName2: '',
    receivingBankAddress1: '',
    receivingBankAddress2: '',
    receivingBankCountry: '',
    intermediarySelection: '',
    intermediaryName: '',
    intermediaryNameCont: '',
    intermediaryAccountNumber: '',
    intermediaryAddress: '',
    intermediaryAddressCont: '',
    intermediaryCountry: '',
    intermediaryPhone: '',
    bankPhoneNumber: '',
    receivingAccountHolderName1: '',
    receivingAccountHolderName2: '',
    receivingAccountHolderAddress1: '',
    receivingAccountHolderAddress2: '',
    receivingAccountHolderCountry: '',
    amountType: '',
    bankID: '',
    labelRefNum: '',
    refNum: '',
    canDisplayReceivingBankPhone: false,
    canDisplayIntermediaryPhone: false,
    creditToSelection: 'no',
    creditToName: '',
    creditToNameCont: '',
    creditToAccountNumber: '',
    creditToAddress: '',
    creditToAddressCont: '',
    creditToCountry: '',
    creditToPhone: '',
    canDisplayCreditToPhone: false,
    requestedDate: '',
    name: '',
    isISOCompliant: false,
    receivingAccountHolderName: '',
    receivingAccountHolderStreetNumber: '',
    receivingAccountHolderStreetName: '',
    receivingAccountHolderApartmentSuiteEtc: '',
    receivingAccountHolderCity: '',
    receivingAccountHolderState: '',
    receivingAccountHolderZip: '',
    receivingAccountHolderDepartment: '',
    receivingAccountHolderBuildingName: '',
    receivingAccountHolderFloor: '',
    receivingAccountHolderTownLocationName: '',
    receivingAccountHolderDistrict: '',
    countryCode: '',
    countryDescription: '',
    intermediaryStreetNumber: '',
    intermediaryStreetName: '',
    intermediaryApartmentSuiteEtc: '',
    intermediaryCity: '',
    intermediaryState: '',
    intermediaryZip: '',
    intermediaryDepartment: '',
    intermediaryBuildingName: '',
    intermediaryFloor: '',
    intermediaryDistrict: '',
    intermediaryTownLocationName: '',
    intermediaryIdentifierList: [],
    intermediaryBankName: '',
    intermediaryBankConcatenatedAddress: '',
    intermediaryBankCountry: '',
    city: '',
    state: '',
    receivingBankStreetNumber: '',
    receivingBankStreetName: '',
    receivingBankApartmentSuiteEtc: '',
    receivingBankCity: '',
    receivingBankState: '',
    receivingBankZip: '',
    receivingBankDepartment: '',
    receivingBankBuildingName: '',
    receivingBankFloor: '',
    receivingBankTownLocationName: '',
    receivingBankDistrict: '',
    recipientStreetNumber: '',
    recipientStreetName: '',
    recipientApartmentSuiteEtc: '',
    recipientCity: '',
    recipientState: '',
    recipientZip: '',
    recipientDepartment: '',
    recipientBuildingName: '',
    recipientFloor: '',
    recipientTownLocationName: '',
    recipientDistrict: '',
    intermediaryConcatenatedAddress: '',

    secondIntermediaryIdentifierList: [],
    secondIntermediaryName: '',
    secondIntermediaryConcatenatedAddress: '',
    secondIntermediaryCountry: '',
    secondIntermediaryAccountNumber: '',

    secondIntermediaryStreetNumber: '',
    secondIntermediaryStreetName: '',
    secondIntermediaryApartmentSuiteEtc: '',
    secondIntermediaryCity: '',
    secondIntermediaryState: '',
    secondIntermediaryZip: '',
    secondIntermediaryDepartment: '',
    secondIntermediaryBuildingName: '',
    secondIntermediaryFloor: '',
    secondIntermediaryTownLocationName: '',
    secondIntermediaryDistrict: '',

    thirdIntermediaryIdentifierList: [],
    thirdIntermediaryName: '',
    thirdIntermediaryConcatenatedAddress: '',
    thirdIntermediaryCountry: '',
    thirdIntermediaryAccountNumber: '',

    thirdIntermediaryStreetNumber: '',
    thirdIntermediaryStreetName: '',
    thirdIntermediaryApartmentSuiteEtc: '',
    thirdIntermediaryCity: '',
    thirdIntermediaryState: '',
    thirdIntermediaryZip: '',
    thirdIntermediaryDepartment: '',
    thirdIntermediaryBuildingName: '',
    thirdIntermediaryFloor: '',
    thirdIntermediaryTownLocationName: '',
    thirdIntermediaryDistrict: '',
    receivingBankName: '',
    receivingBankConcatenatedAddress: '',
    recipientIdentifierList: [],
    recipientBankName: '',
    recipientBankConcatenatedAddress: '',
    recipientBankCountry: '',
    recipientAccountNumber: '',
    recipientAccountHolderAccountNumber: '',
    recipientAccountHolderName: '',
    recipientAccountHolderConcatenatedAddress: '',
    recipientAccountHolderCountry: '',
    isFedWire: true,
    missingThirdPartyAddress: false,
    detailsCallSucceeded: false,
    loading: true,
    error: '',
    hasError: false,
    inputCallV3Finished: false,
    inputCallV3Failed: false,
    verifyCallFinished: false,
    verifyV3CallFinished: false,
    OneTimeAndSloaWiresVerifyV3Finished: false,
    OneTimeAndSloaWiresVerifyV3Failed: false,
    hasNDFALPFA: false
    };
  }),
  
  on(TransactionFormActions.callWiresVerifyV3, (state) => {
    return {
      ...state,
      verifyV3CallFinished: false,
    };
  }),
  on(TransactionFormActions.callWireSloaVerifyV3FromCreateTransaction, (state) => {
    return {
      ...state,
      OneTimeAndSloaWiresVerifyV3Finished: false,
      OneTimeAndSloaWiresVerifyV3Failed: false
    };
  }),
  on(WireActions.wireInputCallSuccessfulV3, (state, {response}) => {
    const isThreeStep = response.sloaInfo?.isoFinancialInstitutions?.length > 2;
    const isFourStep = response.sloaInfo?.isoFinancialInstitutions?.length > 3;
    const firstIntermediaryPosition = isFourStep ? 3 : (isThreeStep ? 2 : 1);
    const accountInfo = response.accountInfo;
    const taxInfo = accountInfo?.taxInfo;
    const cashInfo = accountInfo?.cashInfo;
    return {
      ...state,
      loading: false,
      error: '',
      hasError: false,
      inputCallV3Finished: true,
      inputCallV3Failed: false,
      receivingAccountHolderIso: {
        name: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.name : response.accountNameAddressV2Response?.name,
        accountHolderStreetNumber: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.buildingNumber?.trim() : response.accountNameAddressV2Response?.postalAddress?.buildingNumber,
        accountHolderStreetName: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.streetName?.trim() : response.accountNameAddressV2Response?.postalAddress?.streetName,
        accountHolderApartmentSuiteEtc: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.room?.trim() : response.accountNameAddressV2Response?.postalAddress?.room,
        countryCode: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.country?.trim() : response.accountNameAddressV2Response?.postalAddress?.country,
        receivingBankCity: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.townName?.trim() : response.accountNameAddressV2Response?.postalAddress?.townName,
        receivingBankState: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.countrySubDivision?.trim() : response.accountNameAddressV2Response?.postalAddress?.countrySubDivision,
        zipCode: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.postCode?.trim() : response.accountNameAddressV2Response?.postalAddress?.postCode,
        department: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.department?.trim() : response.accountNameAddressV2Response?.postalAddress?.department,
        buildingName: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.buildingName?.trim() : response.accountNameAddressV2Response?.postalAddress?.buildingName,
        floor: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.floor?.trim() : response.accountNameAddressV2Response?.postalAddress?.floor,
        townLocationName: response.sloaInfo!= null ? response.sloaInfo?.isoParties[0]?.postalAddress?.townLocationName?.trim() : response.accountNameAddressV2Response?.postalAddress?.townLocationName,
        district: response.sloaInfo!= null ? response.sloaInfo?.isoParties[0]?.postalAddress?.districtName?.trim() : response.accountNameAddressV2Response?.postalAddress?.districtName,
        phone: response.accountNameAddressV2Response?.phone ? response.accountNameAddressV2Response?.phone[0]?.number?.trim() : ''
      },
      intermediaryStreetNumber: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.buildingNumber?.trim(),
      intermediaryStreetName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.streetName?.trim(),
      intermediaryApartmentSuiteEtc: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.room?.trim(),
      intermediaryCity: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.townName?.trim() ?? '',
      intermediaryState: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.countrySubDivision?.trim(),
      intermediaryZip: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.postCode?.trim(),
      intermediaryDepartment: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.department?.trim(),
      intermediaryBuildingName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.buildingName?.trim(),
      intermediaryFloor: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.floor?.trim(),
      intermediaryDistrict: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.districtName?.trim(),
      intermediaryTownLocationName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.townLocationName?.trim(),
      intermediaryBankName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.name,
      intermediaryBankConcatenatedAddress:  response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.concatenatedAddress?.trim(),
      intermediaryBankCountry: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.country?.trim(),
      receivingBankDetails: {
        recBankAba: response.sloaInfo?.wiresBankDetails?.receivingBankAba?.toString(),
        recBankName1: response.sloaInfo?.wiresBankDetails?.receivingBankName[0],
        recBankName2: response.sloaInfo?.wiresBankDetails?.receivingBankName[1],
        recBankAddress1: response.sloaInfo?.wiresBankDetails?.receivingBankAddress[0],
        recBankAddress2: response.sloaInfo?.wiresBankDetails?.receivingBankAddress[1],
        recBankCountry: response.sloaInfo?.wiresBankDetails?.receivingBankCountry,
        bankPhoneArea: '',
        bankPhoneNum1: response?.sloaInfo?.wiresBankDetails?.receivingBankPhone,
        bankPhoneNum2: '',
        intermediaryAccount: '',
        intermediaryName1: '',
        intermediaryName2: '',
        intermediaryAddress1: '',
        intermediaryAddress2: '',
        interPhoneArea: '',
        interPhoneNum1: '',
        interPhoneNum2: '',
        interPhoneExt: '',
      },
      receivingBankDetailsIso: {
        recBankAba: response.sloaInfo?.isoFinancialInstitutions[0]?.identifierList[0]?.identifierValue,
        recBankName: response.sloaInfo?.isoFinancialInstitutions[0]?.name,
        recBankAddress: {
          department: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.department?.trim(),
          streetName: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.streetName?.trim(),
          buildingNumber: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.buildingNumber?.trim(),
          buildingName: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.buildingName?.trim(),
          floor: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.floor?.trim(),
          room: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.floor?.trim(),
          postCode: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.postCode?.trim(),
          townName: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.townName?.trim(),
          townLocationName: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.townLocationName?.trim(),
          districtName: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.districtName?.trim(),
          countrySubDivision: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.countrySubDivision?.trim(),
          country: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.country?.trim(),
          concatenatedAddress: response.sloaInfo?.isoFinancialInstitutions[0]?.postalAddress?.concatenatedAddress?.trim() ?? ''
        },
        recBankPhone: response.sloaInfo?.receivingBank?.mailingDetails?.phoneNumber ?? '',
        intermediaryName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.name ?? '',
        intermediaryAccount:  response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.identifierList.filter(x => x.identifierType == "Account")[0]?.identifierValue,
        intermediaryAddress: {
          department: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.department?.trim(),
          streetName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.streetName?.trim(),
          buildingNumber: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.buildingNumber?.trim(),
          buildingName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.buildingName?.trim(),
          floor: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.floor?.trim(),
          room: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.room?.trim(),
          postCode: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.postCode?.trim(),
          townName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.townName?.trim() ?? '',
          townLocationName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.townLocationName?.trim(),
          districtName: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.districtName?.trim(),
          countrySubDivision: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.countrySubDivision?.trim(),
          country: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.country?.trim() ?? '',
          concatenatedAddress: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.postalAddress?.concatenatedAddress?.trim()
        },
        intermediaryPhone: response.sloaInfo?.isoFinancialInstitutions[firstIntermediaryPosition]?.phone ?? ''
      },
      nickname: response.sloaInfo?.nickname ?? '',
      countryList: response.wireResources.countryList,
      withholdFedTax: taxInfo?.withholdFedTaxes ?? false,
      withholdStateTax: taxInfo?.withholdStateTaxes ?? false,
      stateCd: taxInfo?.stateCd ?? '',
      fedTaxPercent: taxInfo?.fedTaxPercent != null ? taxInfo.fedTaxPercent.toString() : '',
      inputIraFields: {
        stateTaxPercent: taxInfo?.stateTaxPercent != null ? taxInfo.stateTaxPercent.toString() : '',
        fedTaxPercent: taxInfo?.fedTaxPercent != null ? taxInfo.fedTaxPercent.toString() : '',
      },
      stateTaxPercent: taxInfo?.stateTaxPercent != null ? taxInfo.stateTaxPercent.toString() : '',
      stateHasTaxes: taxInfo?.stateHasTaxes ?? false,
      stateTypeIndicator: taxInfo?.stateTypeInd ?? '',
      availableCashMMF: cashInfo?.cusAvailableCashMMF ?? '',
      availableCashMargin: cashInfo?.cusAvailableOnMargin ?? '',
      distributionReasonMap:
        taxInfo?.distributionReasonsList ?? [],
      processDateFields: {
        isExtendedProcessingWindow:
          response.processDateFields?.isExtendedProcessingWindow,
        useExtendedProcessDates:
          response.processDateFields?.useExtendedProcessDates,
        standardProcessDates: response.processDateFields?.standardProcessDates,
        extendedProcessDates: response.processDateFields?.extendedProcessDates,
      },
      canDisplayCreditToInfo: response.sloaInfo?.isoFinancialInstitutions?.length > 2,
      creditTo: {
        insitutionName1: response.sloaInfo?.isoFinancialInstitutions?.length > 2 ? response.sloaInfo?.wiresBankDetails?.creditToName[0] : '',
        insitutionName2: response.sloaInfo?.isoFinancialInstitutions?.length > 2 ? response.sloaInfo?.wiresBankDetails?.creditToName[1] : '',
        institutionAddress: response.sloaInfo?.isoFinancialInstitutions?.length > 2 ? response.sloaInfo?.wiresBankDetails?.creditToAddress[0] : '',
        institutionAddressContd: response.sloaInfo?.isoFinancialInstitutions?.length > 2 ? response.sloaInfo?.wiresBankDetails?.creditToAddress[1] : '',
        insitutionAccountNumber: response.sloaInfo?.isoFinancialInstitutions?.length > 2 ? response.sloaInfo?.wiresBankDetails?.creditToAccountNumber : '',
        institutionCountry: response.sloaInfo?.isoFinancialInstitutions?.length > 2 ? response.sloaInfo?.wiresBankDetails?.creditToCountry : '',
        institutionPhoneNumber: response.sloaInfo?.isoFinancialInstitutions?.length > 2 ? response.sloaInfo?.wiresBankDetails?.creditToPhone : ''
      },
      isFedWire: response.sloaInfo?.isFedWire ?? true,
      missingThirdPartyAddress: (response.sloaInfo?.beneficiary?.mailingDetails?.addressLineOne?.trim() === '' || response.sloaInfo?.beneficiary?.mailingDetails?.countryCode?.trim() === ''),
      missingIntermediaryAddress: (response.sloaInfo?.intermediary?.mailingDetails?.addressLineOne?.trim() === ''),
      hasNDFALPFA: accountInfo?.restrictedByNdfaOrLpfa ?? false,
      hasCustodianRole: accountInfo?.hasCustodianRole ?? false,
      cashieringIraAgreementText: response.cashieringIraAgreementText,
      palAgreementText: response.palAgreementText ?? '',
      palAgreementAcknowledgement: response.palAgreementAcknowledgement ?? '',
      regShortName: accountInfo?.accountDisplayRecord?.regShortName,
      isIrsAba: response.sloaInfo?.isIrsAba,
      taxRemittance: response.sloaInfo?.taxRemittance,
      isISOCompliant: response.sloaInfo?.isISOCompliant
    };
  }),
  
  on(WireActions.wireInputCallV3TemplateFlowSuccessful, (state, {response}) => {
    const accountInfo = response.accountInfo;
    const taxInfo = accountInfo?.taxInfo;
    const cashInfo = accountInfo?.cashInfo;
    return {
      ...state,
      loading: false,
      error: '',
      hasError: false,
      inputCallV3Finished: true,
      inputCallV3Failed: false,
      receivingAccountHolderIso: {
        name: response.accountNameAddressV2Response?.name,
        accountHolderStreetNumber: response.accountNameAddressV2Response?.postalAddress?.buildingNumber,
        accountHolderStreetName: response.accountNameAddressV2Response?.postalAddress?.streetName,
        accountHolderApartmentSuiteEtc: response.accountNameAddressV2Response?.postalAddress?.room,
        countryCode: response.accountNameAddressV2Response?.postalAddress?.country,
        receivingBankCity: response.accountNameAddressV2Response?.postalAddress?.townName,
        receivingBankState: response.accountNameAddressV2Response?.postalAddress?.countrySubDivision,
        zipCode: response.accountNameAddressV2Response?.postalAddress?.postCode,
        department: response.accountNameAddressV2Response?.postalAddress?.department,
        buildingName: response.accountNameAddressV2Response?.postalAddress?.buildingName,
        floor: response.accountNameAddressV2Response?.postalAddress?.floor,
        townLocationName: response.accountNameAddressV2Response?.postalAddress?.townLocationName,
        district: response.accountNameAddressV2Response?.postalAddress?.districtName,
        phone: response.accountNameAddressV2Response?.phone ? response.accountNameAddressV2Response?.phone[0]?.number?.trim() : ''
      },
      countryList: response.wireResources.countryList,
      withholdFedTax: taxInfo?.withholdFedTaxes ?? false,
      withholdStateTax: taxInfo?.withholdStateTaxes ?? false,
      stateCd: taxInfo?.stateCd ?? '',
      fedTaxPercent: taxInfo?.fedTaxPercent != null ? taxInfo.fedTaxPercent.toString() : '',
      inputIraFields: {
        stateTaxPercent: taxInfo?.stateTaxPercent != null ? taxInfo.stateTaxPercent.toString() : '',
        fedTaxPercent: taxInfo?.fedTaxPercent != null ? taxInfo.fedTaxPercent.toString() : '',
      },
      stateTaxPercent: taxInfo?.stateTaxPercent != null ? taxInfo.stateTaxPercent.toString() : '',
      stateHasTaxes: taxInfo?.stateHasTaxes ?? false,
      stateTypeIndicator: taxInfo?.stateTypeInd ?? '',
      availableCashMMF: cashInfo?.cusAvailableCashMMF ?? '',
      availableCashMargin: cashInfo?.cusAvailableOnMargin ?? '',
      distributionReasonMap:
        taxInfo?.distributionReasonsList ?? [],
      processDateFields: {
        isExtendedProcessingWindow:
          response.processDateFields?.isExtendedProcessingWindow,
        useExtendedProcessDates:
          response.processDateFields?.useExtendedProcessDates,
        standardProcessDates: response.processDateFields?.standardProcessDates,
        extendedProcessDates: response.processDateFields?.extendedProcessDates,
      },
      canDisplayCreditToInfo: response.sloaInfo?.hasOwnProperty('creditTo'),
      creditTo: {
        insitutionName1: response.sloaInfo?.creditTo?.mailingDetails?.namePartOne,
        insitutionName2: response.sloaInfo?.creditTo?.mailingDetails?.namePartTwo,
        institutionAddress: response.sloaInfo?.creditTo?.mailingDetails?.addressLineOne,
        institutionAddressContd: response.sloaInfo?.creditTo?.mailingDetails?.addressLineTwo,
        insitutionAccountNumber: response.sloaInfo?.creditTo?.id,
        institutionCountry: response.sloaInfo?.creditTo?.mailingDetails?.countryName,
        institutionPhoneNumber: response.sloaInfo?.creditTo?.mailingDetails?.phoneNumber
      },
      isFedWire: response.sloaInfo?.isFedWire ?? true,
      missingThirdPartyAddress: (response.sloaInfo?.beneficiary?.mailingDetails?.addressLineOne?.trim() === '' || response.sloaInfo?.beneficiary?.mailingDetails?.countryCode?.trim() === ''),
      missingIntermediaryAddress: (response.sloaInfo?.intermediary?.mailingDetails?.addressLineOne?.trim() === ''),
      hasNDFALPFA: accountInfo?.restrictedByNdfaOrLpfa ?? false,
      hasCustodianRole: accountInfo?.hasCustodianRole ?? false,
      cashieringIraAgreementText: response.cashieringIraAgreementText,
      regShortName: accountInfo?.accountDisplayRecord?.regShortName
    };
  }),
  
  on(TransactionFormActions.templatePrefilledFlowStarted, (state, {response, mapRecipientFromDraft}) => {
    let recAccountHolderIso = {
      ...state.receivingAccountHolderIso
    };
    if (mapRecipientFromDraft) {
      recAccountHolderIso.accountHolderStreetNumber = response.draftObject?.beneficiary?.buildingNumber ?? '',
      recAccountHolderIso.accountHolderStreetName = response.draftObject?.beneficiary?.streetName ?? '',
      recAccountHolderIso.accountHolderApartmentSuiteEtc = response.draftObject?.beneficiary?.room ?? '',
      // country codes have 2 characters
      recAccountHolderIso.countryCode = response.draftObject?.beneficiary?.countryCode ?? '',
      recAccountHolderIso.countryDescription = response.draftObject?.intermediary?.mailingDetails?.countryName ?? '',
      recAccountHolderIso.receivingBankCity = response.draftObject?.beneficiary?.townName ?? '',
      recAccountHolderIso.receivingBankState = response.draftObject?.beneficiary?.countrySubDivision ?? '',
      recAccountHolderIso.zipCode = response.draftObject?.beneficiary?.zipCode ?? '',
      recAccountHolderIso.department = response.draftObject?.beneficiary?.department ?? '',
      recAccountHolderIso.buildingName = response.draftObject?.beneficiary?.buildingName ?? '',
      recAccountHolderIso.floor = response.draftObject?.beneficiary?.floor ?? '',
      recAccountHolderIso.townLocationName = response.draftObject?.beneficiary?.townLocationName ?? '',
      recAccountHolderIso.district = response.draftObject?.beneficiary?.districtName ?? ''
    }
    return {
      ...state,
      ...(state.detailsCallSucceeded ? {
        receivingBankDetails: state.receivingBankDetails,
        receivingBankDetailsIso: state.receivingBankDetailsIso,
        abaStatusCode: state.abaStatusCode,
        receivingBankAba: state.receivingBankAba,
        abaMessageFields: state.abaMessageFields,
        isIrsAba: state.isIrsAba
      } : {
        receivingAccountHolderIso: recAccountHolderIso,
        receivingBankDetails: {
          ...state.receivingBankDetails,
          recBankAba: response.draftObject.beneficiaryBankId,
          recBankName1: response.draftObject.beneficiaryBank.namePartOne,
          recBankName2: response.draftObject.beneficiaryBank.namePartTwo,
          recBankAddress1: response.draftObject.beneficiaryBank.addressLineOne,
          recBankAddress2: response.draftObject.beneficiaryBank.addressLineTwo,
          recBankCountry: response.draftObject.beneficiaryBank.countryCode,
          intermediaryAccount: response.draftObject.intermediary.id,
          intermediaryName1: response.draftObject.intermediary.mailingDetails.namePartOne,
          intermediaryName2: response.draftObject.intermediary.mailingDetails.namePartTwo,
          intermediaryAddress1: response.draftObject.intermediary.mailingDetails.addressLineOne,
          intermediaryAddress2: response.draftObject.intermediary.mailingDetails.addressLineTwo,
        },
        receivingBankDetailsIso : {
          ...state.receivingBankDetailsIso,
          recBankAba: response.draftObject.beneficiaryBankId,
          recBankName: response.draftObject.beneficiaryBank.name ?? '',
          recBankAddress: {
            department: '',
            streetName: '',
            buildingNumber: '',
            buildingName: '',
            floor: '',
            room: '',
            postCode: '',
            townName: response.draftObject?.beneficiaryBank?.townName ?? '',
            townLocationName: '',
            districtName: '',
            countrySubDivision: response.draftObject?.beneficiaryBank?.countrySubDivision ?? '',
            country: response.draftObject?.beneficiaryBank?.countryCode ?? '',
            concatenatedAddress: ''
          },
          recBankPhone: response.draftObject.beneficiaryBank.phoneNumber,
          intermediaryAccount: response.draftObject.intermediary.id,
          intermediaryName: response?.draftObject?.intermediary?.mailingDetails?.name ?? '',
          intermediaryAddress: {
            department: response.draftObject?.intermediary?.mailingDetails?.department ?? '',
            streetName: response.draftObject?.intermediary?.mailingDetails?.streetName ?? '',
            buildingNumber: response.draftObject?.intermediary?.mailingDetails?.buildingNumber ?? '',
            buildingName: response.draftObject?.intermediary?.mailingDetails?.buildingName ?? '',
            floor: response.draftObject?.intermediary?.mailingDetails?.floor ?? '',
            room: response.draftObject?.intermediary?.mailingDetails?.room ?? '',
            postCode: response.draftObject?.intermediary?.mailingDetails?.zipCode ?? '',
            townName: response.draftObject?.intermediary?.mailingDetails?.townName ?? '',
            townLocationName: response.draftObject?.intermediary?.mailingDetails?.townLocationName ?? '',
            districtName: response.draftObject?.intermediary?.mailingDetails?.districtName ?? '',
            countrySubDivision: response.draftObject?.intermediary?.mailingDetails?.countrySubDivision ?? '',
            country: response.draftObject?.intermediary?.mailingDetails?.country ?? '',
            concatenatedAddress: ''
          },
          intermediaryPhone: response.draftObject.intermediary.mailingDetails.phoneNumber
        },
        isIrsAba: response.draftObject?.isIrsAba ?? false
      }),
      withholdFedTax: response.draftObject.iraTransactionRequest.isWithholdFedTax,
      withholdStateTax: response.draftObject.iraTransactionRequest.isWithholdStateTax,
      fedTaxPercent: response.draftObject.iraTransactionRequest.fedTaxPercentage.toString(),
      isISOCompliant : response.draftObject?.isIsoCompliant,
      inputIraFields: {
        stateTaxPercent: response.draftObject.iraTransactionRequest.stateTaxPercentage.toString(),
        fedTaxPercent: response.draftObject.iraTransactionRequest.fedTaxPercentage.toString(),
      },
      stateTaxPercent: response.draftObject.iraTransactionRequest.stateTaxPercentage.toString(),
      canDisplayCreditToInfo: response.draftObject?.hasOwnProperty('creditTo'),
      creditTo: {
        insitutionName1: response.draftObject?.creditTo?.mailingDetails.namePartOne,
        insitutionName2: response.draftObject?.creditTo?.mailingDetails.namePartTwo,
        institutionAddress: response.draftObject?.creditTo?.mailingDetails.addressLineOne,
        institutionAddressContd: response.draftObject?.creditTo?.mailingDetails.addressLineTwo,
        insitutionAccountNumber: response.draftObject?.creditTo?.id,
        institutionCountry: response.draftObject?.creditTo?.mailingDetails.countryName,
        institutionPhoneNumber: response.draftObject?.creditTo?.mailingDetails.phoneNumber
      },
      missingThirdPartyAddress: response.draftObject?.isIsoCompliant ? state.missingThirdPartyAddress :
        (response.draftObject?.beneficiary?.addressLineOne?.trim() === '' || response.draftObject?.beneficiary?.countryCode?.trim() === ''),
      distributionReason: response.draftObject.iraTransactionRequest.distributionReason,
    };
  }),
  on(WireActions.wireInputFailedV3, WireActions.wireInputV3TemplateFlowFailed, (state, err) => {
    return {
      ...state,
      loading: false,
      error: err.message,
      hasError: true,
      inputCallV3Failed: true
    };
  }),
  on(
    TransactionFormActions.sloaSelectionChanged,
    TransactionFormActions.cancelClicked,
    ReviewPageActions.cancelClicked,
    ConfirmationPageActions.viewTransactionStatusClicked,
    ConfirmationPageActions.createAnotherRequestClicked,
    InitReleaseActions.getInitReleaseList,
    () => initialWireInfoState
  ),
  on(
    TransactionFormActions.callWiresVerifyV3,
    TransactionFormActions.callWireSloaVerifyV3FromCreateTransaction,
    ReviewPageActions.editClicked,
    (state, _) => {
      return {
        ...state,
        verifyCallFinished: false,
        verifyV3CallFinished: false,
        isSubmitAndCreate: false,
        OneTimeAndSloaWiresVerifyV3Finished: false,
        OneTimeAndSloaWiresVerifyV3Failed: false,
      };
    }
  ),
  on(WireActions.verifyV3CallFailed, WireActions.callWireSloaVerifyV3FromCreateTransactionFailed, (state, err) => {
    let errMsg = err.message;
    if (err.status === 400 && err.error?.errors && err.error.errors[0]) {
      errMsg = err.error.errors[0].detail;
    }
    return {
      ...state,
      OneTimeAndSloaWiresVerifyV3Failed: true,
      loading: false,
      error: errMsg,
      hasError: true,
      caseId: state?.caseId?.split(",")[0] != undefined ? state?.caseId?.split(",")[0] : state.caseId,
      caseKey: state?.caseKey?.split(",")[0] != undefined ? state?.caseKey?.split(",")[0] : state.caseKey,
    };
  }),
  on(WireActions.callWireSloaVerifyV3FromCreateTransactionSuccessful, (state, response) => {
    return {
      ...state,
      OneTimeAndSloaWiresVerifyV3Finished: true,
      OneTimeAndSloaWiresVerifyV3Failed: false,
      loading: false,
      taxRemittance: response?.taxRemittance,
      caseId: state?.caseId?.split(",")[0] != undefined ? (state?.caseId?.split(",")[0] + ", " + response.transactionDetails?.caseId) : response.transactionDetails?.caseId,
      caseKey: state?.caseKey?.split(",")[0] != undefined ? (state?.caseKey?.split(",")[0] + ", " + response.uiFields?.caseKey) : response.uiFields?.caseKey,
    }
  }),
  on(WireActions.verifyV3CallSuccessful, (state, {response}) => {
    const fedTax = TaxAmountAndPercentageFormatter(
      response.transactionDetails.fedTax
    );
    const stateTax = TaxAmountAndPercentageFormatter(
      response.transactionDetails.stateTax
    );

    return {
      ...state,
      loading: false,
      verifyV3CallFinished: true,
      wireFee: response.transactionDetails.wireFee,
      clientAuthorizationNeeded: response.uiFields.isClientAuthorizationNeeded,
      warningList: response.uiFields.warningsList,
      warningsList: response.uiFields.warningsList,
      eauthAccess: response.uiFields.eAuthAccess,
      attestationSubmittedBy: response.transactionDetails.attestationSubmittedBy,
      eAuthModel: {
        ...response.eAuthModel,
        custAcctAuthorizationsList: {
          ...response.eAuthModel?.custAcctAuthorizationsList,
          eAuthCustomerList:
            response.eAuthModel?.custAcctAuthorizationsList?.eAuthCustomerList.map(
              (customer) => {
                const mappedCustomer = new EAuthModelCustomer(customer);
                mappedCustomer.isCustomerEAuthEligible = customer.eauthInd;
                return mappedCustomer;
              }
            ) ?? [],
        },
      },
      toDetails: response.toDetails,
      stateTaxAmount: stateTax.amount,
      fedTaxAmount: fedTax.amount,
      stateTaxPercent: stateTax.percentage,
      fedTaxPercent: fedTax.percentage,
      distributionReasonDescription: response.transactionDetails.distributionReason,
      wireAmount: response.transactionDetails.wireAmount,
      withdrawalAmount: response.transactionDetails.withdrawalAmount,
      transmissionNotes: response?.transactionDetails?.additionalWireInstructions,
      caseId: response.transactionDetails.caseId,
      caseKey: response.uiFields.caseKey,
      requestedDate: response.transactionDetails.requestDate,
      processDate: response.transactionDetails.processDate,
      taxRemittance: response.taxRemittance,
      isPendingOnlyForCTWE: response.uiFields.isPendingOnlyForCTWE,
      isTransactionFromSLOAOrSLOA: response.uiFields.isTransactionFromSLOAOrSLOA,
      authResponse: response.wireAuthResponse,
      revalidationStatus: response.revalidation?.status ?? '',
      isFedWire: response.uiFields.isFedWire,
      revalidation :  {
        ...response.revalidation,
        status : response?.revalidation?.status ?? '',
        errors : response?.revalidation?.errors ?? [],
        fieldsUpdated : response?.revalidation?.fieldsUpdated ?? []
      },
      affirmationRequired: response.uiFields?.affirmationRequired,
      error: '',
      hasError: false
    };
  }),

  on(WireActions.acknowledgeCallV3Successful, (state, response) => {
    let formatDatePipe = new FormatDatePipe();
    let hasFedTax = +response.transactionDetails?.fedTaxRate > 0;
    // we don't get some info back from ack when just initiating, so leave those fields from verify response
    let isInitiatorFlow: boolean = (state.authResponse?.pendForRelease && !state.authResponse?.canRelease) ?? false;

    const fedTax = TaxAmountAndPercentageFormatter(
      response.transactionDetails?.fedTax ?? ''
    );
    const stateTax = TaxAmountAndPercentageFormatter(
      response.transactionDetails?.stateTax ?? ''
    );
    return {
      ...state,
      withholdFedTax: hasFedTax,
      withholdStateTax: response.transactionDetails?.isWithholdStateTaxes?.toLowerCase() === "yes" ? true : false,
      pendReasons: response.transactionDetails?.pendingReasons,
      transferId: `${response.fromDetails.subAccount}-${response.uiFields.cashieringRequestId}-${response.uiFields.cashieringRequestSecondId}`,
      warningsList: response.uiFields.warningsList,
      requestedDate: formatDatePipe.transform(response.transactionDetails?.requestDate),
      clientAuthorizationNeeded: response.uiFields.isClientAuthorizationNeeded,
      isPendingOnlyForCTWE: response.uiFields.isPendingCtwe,
      wireAmount: isInitiatorFlow ? state.wireAmount : response.transactionDetails.wireAmount,
      stateTaxAmount: isInitiatorFlow ? state.stateTaxAmount : stateTax.amount,
      fedTaxAmount: isInitiatorFlow ?  state.fedTaxAmount : fedTax.amount,
      stateTaxPercent: stateTax.percentage,
      fedTaxPercent: fedTax.percentage,
    }
  }),
  on(TransactionFormActions.distributionReasonChanged, (state, response) => {
    if (response.transactionType === transactionTypes.wire) {
      return {
        ...state,
        distributionReason: response.distributionReason,
      };
    }
    return { ...state };
  }),
  on(StandingAuthorizationsActions.loadSloas, ViewPageActions.startTransactionButtonClicked, (state, _) => {
    return {
      ...state,
      inputCallV3Finished: false,
      inputCallV3Failed: false,
      standingAuthCallSucceeded: false,
    };
  }),
  on(
    StandingAuthorizationsActions.loadSloasSuccess,
    (state, _) => {
      return {
        ...state,
        standingAuthCallSucceeded: true,
      };
    }
  ),
  on(
    StandingAuthorizationsActions.loadSloasFailure,
    (state, _) => {
      return {
        ...state,
        standingAuthCallSucceeded: false,
      };
    }
  ),
  on(TransactionFormActions.editLoadComplete, (state) => {
    return {
      ...state,
      inputCallV3Finished: true,
      standingAuthorizationsCallFinished: true,
    };
  }),
  on(WireActions.inquiryCallSuccessful, (state, response) => {
    const { wireInquiryResponse } = response;
    const percentFormatPipe = new FormatPercentPipe();
    const fedArr: string[] =  wireInquiryResponse.canDisplayFedTax && wireInquiryResponse.fedTaxFormatted ? wireInquiryResponse.fedTaxFormatted.split(' ') : [];
    const stateArr: string[] = wireInquiryResponse.stateTaxFormatted ? wireInquiryResponse.stateTaxFormatted.split(' ') : [];

    return {
      ...state,
      wireAmount: wireInquiryResponse.amount,
      processDate: wireInquiryResponse.processDate,
      withdrawalAmount: wireInquiryResponse.withdrawalAmount,
      wireFee: wireInquiryResponse.wireFee,
      fedTaxPercent: fedArr.length > 1 ? percentFormatPipe.transform(fedArr[1]) : percentFormatPipe.transform(fedArr[0]),
      fedTaxAmount: fedArr ? fedArr[0] : '',
      stateTaxPercent: stateArr.length > 1 ? stateArr[1].replace(/[()]/g,'') : stateArr.length > 0 ? stateArr[0].replace(/[()]/g,'') : '',
      stateTaxAmount: stateArr ? stateArr[0] : '',
      isFedWire: wireInquiryResponse.receivingBankCountry === 'UNITED STATES' ? true : false,
      distributionReasonDescription: wireInquiryResponse.distributionReason,
      pendReasons: wireInquiryResponse.pendReasonsListSet,
      toDetails: {
        ...state.toDetails,
        beneficiaryCountry: state.toDetails.beneficiaryCountry ? state.toDetails.beneficiaryCountry : wireInquiryResponse.beneficiaryCountry
      },
      receivingBankClearingSysId: wireInquiryResponse.isISOCompliant ? wireInquiryResponse.isoFinancialInstitutions[0]?.clearingSystemBankId?.identifierValue ?? '' : "",
      nickname: wireInquiryResponse.nickname,
      transferId: `${wireInquiryResponse.subAccount}-${wireInquiryResponse.cashieringRequestId}-${wireInquiryResponse.cashieringSecRequestId}`,
      caseKey: wireInquiryResponse.aceCaseId,
      withholdFedTax: wireInquiryResponse.withholdFedTaxIndicator?.toLowerCase() === 'yes',
      withholdStateTax: wireInquiryResponse.withholdStateTaxIndicator?.toLowerCase() === 'yes',
      stateHasTaxes: wireInquiryResponse.canDisplayStateTax,
      isTransactionFromSLOAOrSLOA: wireInquiryResponse.isTransactionFromSLOAForWire,
      isBsloaTransaction: wireInquiryResponse.bSLOATxn,
      isIrsAba: wireInquiryResponse.isIrsAba,
      taxRemittance: wireInquiryResponse.taxRemittance,
      foreignCurrencyFields: {
        currencyAmount: wireInquiryResponse.fxAmount,
        currencyType: wireInquiryResponse.currencyName,
        exchangeRate: wireInquiryResponse.customerFxRate
      },
      receivingAccountHolderIdentifierList: wireInquiryResponse.isoUIFields?.recipient?.identifierList
    } 
  }),
  on(ViewPageActions.backButtonClicked,
    ViewPageActions.backButtonClickedFromMsv,
    () => {
    return {
      ...initialWireInfoState
    }
  }),
  on(ReviewPageActions.clearAttentionMessage, (state, _) => {
    return {
      ...state,
      warningsList: [],
    };
  }),
  on(ReviewPageActions.submitAndCreateToggled, (state, payload) => {
    const isSubmitAndCreate = payload.isSubmitAndCreate;

    return {
      ...state,
      isSubmitAndCreate
    }
  }),
  on(ReviewPageActions.saveAsTemplateToggled, (state) => {
    return {
      ...state,
      isSubmitAndCreate: false
    }
  }),
  on(TransactionsTableActions.setCurrentViewedTemplate, (state, payload) => {
    return {
      ...state,
      withdrawalAmount: payload.template?.draftObject.amount ? amountFormatter.format(payload.template?.draftObject.amount) : '',
      nickname: payload.template?.draftObject.nickname ?? '',
      isIrsAba: payload.template?.draftObject.isIrsAba ?? false,
      taxRemittance: payload.template?.draftObject.taxRemittance ?? {
        taxId: '',
        taxMonthCode: '',
        taxTypeCode: '',
        taxYear: '',
        additionalInfo: ''
      },
    }
  }),
  on(AccountInfoActions.loadAccountInfoSuccess, (state, info) => {
    return {
      ...state,
      eAuthModel: {
        ...state.eAuthModel,
        custAcctSLOAAuthorizationsList: {
          ...state.eAuthModel.custAcctSLOAAuthorizationsList,
          eAuthCustomerList: UpdateEauthCustomers(state.eAuthModel.custAcctSLOAAuthorizationsList.eAuthCustomerList, info)
        },
        custAcctAuthorizationsList: {
          ...state.eAuthModel.custAcctAuthorizationsList,
         eAuthCustomerList: UpdateEauthCustomers(state.eAuthModel.custAcctAuthorizationsList.eAuthCustomerList, info)
        }
      }
    }
  }),
  on(InitReleaseActions.initReleaseByDraftIdSuccessful, (state, { response, isSloa }) => {
    if (isSloa || response.transactionType !== 'wire') return state;
    return {
      ...state,
      isFedWire: response.draftObject.recBankCountry === 'UNITED STATES' || response.draftObject.recBankCountry === 'US',
      authResponse: {
        ...state.authResponse,
        draftId: response.draftId
      },
      distributionReasonMap: [
        {
          code: response.draftObject.distributionReason?.toString().toLocaleUpperCase()[0] ?? '',
          subCode: response.draftObject.distributionReason?.toString().split('-')[1].trim() ?? '',
          description: response.draftObject.distributionReasonDescription ?? ''
        }
      ],
      caseKey: response.draftObject.aceKey ?? '',
      caseId: response.draftObject.aceCaseId ?? '',
      isIrsAba: response.draftObject.isIrsAba ?? response.draftObject.IsIrsAba ?? false,
      taxRemittance: response.draftObject.taxRemittance ?? response.draftObject.TaxRemittance ?? {
        taxId: '',
        taxMonthCode: '',
        taxTypeCode: '',
        taxYear: '',
        additionalInfo: ''
      },
    }
  })
);

function UpdateEauthCustomers(eAuthCustomerList: EAuthModelCustomer[], info: AccountInfoResponse): EAuthModelCustomer[] {
  let list: EAuthModelCustomer[] = [];
  eAuthCustomerList.forEach(item => {
    let update = info.eauthorization.customers.find(customer => {
      return customer.customerId === item.customerId
    })
    if (update)
    {
      let result: EAuthModelCustomer =
      {
        isAccountWebEnabled: update.isAccountWebEnabled,
        customerWebEnrolled: "false",
        customerId: update.customerId,
        isCustomerWebEnrolled: update.isCustomerWebEnrolled,
        emailId: update.emailId,
        firstName: update.firstName,
        lastName: update.lastName,
        loginIdEnrollStatus: update.loginIdEnrollmentStatus,
        isDisplayAllowed: update.displayIndicator,
        isCustomerEAuthEligible: item.isCustomerEAuthEligible,
        organizationName: update.organizationName,
        eauthInd: item.eauthInd,
        typeCode: update.typeCode,
        customerRestrictionReason: item.customerRestrictionReason,
        accountRoles: update.accountRoles,
        eligibility: item.eligibility
      }
      list.push(result);
    } else {
      list.push(item);
    }
  });
  return list;
}
